"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportInput = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const button_1 = require("../../../components/button/button");
const reporting_styles_1 = require("../reporting-styles");
const report_settings_form_1 = require("./report-settings-form");
function ReportInput({ generate, exportClick, formRef, definition, exportTag, report, }) {
    const intl = react_intl_1.useIntl();
    const classes = reporting_styles_1.useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.parametersWrapper },
            react_1.default.createElement(report_settings_form_1.ReportSettingsForm, { ref: formRef, definition: definition }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(Box_1.default, { display: "flex" },
                react_1.default.createElement(button_1.Button, { outlined: true, label: intl.formatMessage({
                        id: 'EAS_REPORTING_INPUT_BUTTON_GENERATE',
                        defaultMessage: 'Generovat',
                    }), onClick: generate, disabled: (definition === null || definition === void 0 ? void 0 : definition.autogenerate) || definition === undefined }),
                react_1.default.createElement(Box_1.default, { width: 10 }),
                exportTag != null && (react_1.default.createElement(button_1.Button, { outlined: true, label: intl.formatMessage({
                        id: 'EAS_REPORTING_INPUT_BUTTON_EXPORT',
                        defaultMessage: 'Exportovat',
                    }), onClick: exportClick, disabled: definition === undefined || report === null }))))));
}
exports.ReportInput = ReportInput;
//# sourceMappingURL=report-input.js.map